// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Tag, { TagPresentationProps } from "@insite/mobius/Tag";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import TagWrapper, { TagWrapperProps } from "@store/Library/Components/Toolkit/TagWrapper";
import { tableFilterProps } from "@store/Themes/common/props/table";
import updateParameter from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/Handlers/UpdateParameter";
import {
    useTrailerTrackingV2DataView,
    useTrailerTrackingV2State,
} from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/TrailerTrackingV2Hooks";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import usePreviousExisting from "@toolkit/Framework/Common/Hooks/usePreviousExisting";
import { TrailerTrackingV2DwellTimeOperatorApiValues } from "@store/Framework/Types/ApiModels";

const dwellTimeOperatorEntries = Object.entries(TrailerTrackingV2DwellTimeOperatorApiValues);

const getDwellTimeOperatorLabel = (dwellTimeOperatorValue: string) => {
    const dwellTimeOperatorKey = dwellTimeOperatorEntries.find(([key, value]) => value === dwellTimeOperatorValue);

    return dwellTimeOperatorKey
        ? translate(`TrailerTrackingDwellTimeOperator_${dwellTimeOperatorKey[0]}`)
        : dwellTimeOperatorValue;
};

export interface trailerTrackingV2FilterTagsStyles {
    appliedFiltersContainer?: InjectableCss;
    appliedFilterTag?: TagPresentationProps;
    tagWrapper?: TagWrapperProps;
}

export const trailerTrackingV2FilterTagsStyles: trailerTrackingV2FilterTagsStyles = {
    tagWrapper: tableFilterProps.tagWrapper,
};

const styles = trailerTrackingV2FilterTagsStyles;

const TrailerTrackingV2FilterTags = () => {
    const dispatch = useAppDispatch();
    const dataView = useTrailerTrackingV2DataView();
    const previousPlants = usePreviousExisting(dataView.plants);
    const plants = dataView.plants || previousPlants;

    const {
        alertsOnly,
        billingType,
        customerSequence,
        dwellTimeDays,
        dwellTimeOperator,
        onSiteOnly,
        plantCode,
        poNumber,
        trailerId,
    } = useTrailerTrackingV2State().parameter;

    const getPlantName = (code: string): string => {
        return plants?.filter(plant => plant.code === code)[0].displayName || code;
    };

    const hasDwellTime = dwellTimeOperator && typeof dwellTimeDays === "number";

    if (
        !alertsOnly &&
        !billingType &&
        !customerSequence &&
        !hasDwellTime &&
        !onSiteOnly &&
        !plantCode &&
        !poNumber &&
        !trailerId
    ) {
        return null;
    }

    return (
        <TagWrapper {...styles.tagWrapper}>
            {alertsOnly && (
                <Tag {...styles.appliedFilterTag} onDelete={() => dispatch(updateParameter({ alertsOnly: false }))}>
                    {translate("Only Locations with Alerts")}
                </Tag>
            )}
            {billingType && (
                <Tag {...styles.appliedFilterTag} onDelete={() => dispatch(updateParameter({ billingType: "" }))}>
                    {`${translate("{0}:", translate("Billing Type"))} ${billingType}`}
                </Tag>
            )}
            {customerSequence && (
                <Tag {...styles.appliedFilterTag} onDelete={() => dispatch(updateParameter({ customerSequence: "" }))}>
                    {`${translate("{0}:", translate("Ship To"))} ${customerSequence}`}
                </Tag>
            )}
            {hasDwellTime && (
                <Tag {...styles.appliedFilterTag} onDelete={() => dispatch(updateParameter({ dwellTimeOperator: "" }))}>
                    {`${translate("{0}:", translate("Dwell Time"))} ${getDwellTimeOperatorLabel(dwellTimeOperator)} ${dwellTimeDays} ${translate("Days")}`}
                </Tag>
            )}
            {onSiteOnly && (
                <Tag {...styles.appliedFilterTag} onDelete={() => dispatch(updateParameter({ onSiteOnly: false }))}>
                    {translate("Only locations with drop trailers on site")}
                </Tag>
            )}
            {plantCode && (
                <Tag {...styles.appliedFilterTag} onDelete={() => dispatch(updateParameter({ plantCode: "" }))}>
                    {`${translate("{0}:", translate("Greif Location"))} ${getPlantName(plantCode)}`}
                </Tag>
            )}
            {poNumber && (
                <Tag {...styles.appliedFilterTag} onDelete={() => dispatch(updateParameter({ poNumber: "" }))}>
                    {`${translate("{0}:", translate("PO #"))} ${poNumber}`}
                </Tag>
            )}
            {trailerId && (
                <Tag {...styles.appliedFilterTag} onDelete={() => dispatch(updateParameter({ trailerId: "" }))}>
                    {`${translate("{0}:", translate("Trailer ID"))} ${trailerId}`}
                </Tag>
            )}
        </TagWrapper>
    );
};

export default TrailerTrackingV2FilterTags;
